import { render, staticRenderFns } from "./setup-church-staff.vue?vue&type=template&id=d8c3492c&"
import script from "./setup-church-staff.vue?vue&type=script&lang=js&"
export * from "./setup-church-staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports